// @owners { team: patients-team }
import { COLORS, SPACING } from '@alto/design-library-tokens';
import { Column } from '@alto/design-system';
import React from 'react';
import styled from 'styled-components';
import { Text } from '~web/features/essentials/primitives/Text';

type Props = {
  readonly text: string;
};

const StyledColumn = styled(Column)`
  background-color: ${COLORS.BACKGROUND_COLORS.PRIMARY_LIGHTER};
  min-width: 24px;
  border-radius: 12px;
  padding: 0 ${SPACING.STATIC.XS.px};
`;

export const ButtonSideText = ({ text }: Props) => {
  return (
    <StyledColumn>
      <Text
        title={text}
        color="PRIMARY"
      />
    </StyledColumn>
  );
};
